import * as React from 'react';
import PropTypes from 'prop-types';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateRangePicker } from 'react-date-range';
import dayjs from 'dayjs';

function DatePickerDialogContent({ handleSelectionRange }) {
  const [maxDate, setMaxDate] = React.useState(undefined);
  const [selectionRange, setSelectionRange] = React.useState({
    startDate: new Date().setDate(new Date().getDate() - 1),
    endDate: new Date().setDate(new Date().getDate() - 1),
    key: 'selection'
  });

  const handleSelect = React.useCallback(
    (ranges) => {
      const newSelection = {
        ...selectionRange,
        ...(ranges?.selection || {})
      };
      setSelectionRange(newSelection);
      handleSelectionRange(newSelection);
    },
    [selectionRange, handleSelectionRange]
  );

  React.useEffect(() => {
    if (dayjs(selectionRange.startDate).isSame(selectionRange.endDate)) {
      if (dayjs(selectionRange?.startDate).add(13, 'day') > dayjs()) {
        setMaxDate(new Date(dayjs().subtract(1, 'day')));
        return;
      }

      setMaxDate(new Date(dayjs(selectionRange.startDate).add(13, 'day')));
    } else {
      setMaxDate(new Date(dayjs().subtract(1, 'day')));
    }
  }, [selectionRange]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        onChange={handleSelect}
        ranges={[selectionRange]}
        maxDate={maxDate}
        disabledDates={[new Date()]}
      />
    </LocalizationProvider>
  );
}

DatePickerDialogContent.propTypes = {
  handleSelectionRange: PropTypes.func.isRequired
};

export { DatePickerDialogContent };
